import '../../sass/components/_block_about-team.scss';
import Swiper, { Navigation, Pagination } from 'swiper';

const breakpoint = window.matchMedia('(min-width:1024px)');

let mySwiper;

const enableSwiper = function teamCarousel() {
    mySwiper = new Swiper('.swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        pagination: {
            el: '.swiper__pagination',
            clickable: true,
            type: 'bullets',
        },
    });
};
// eslint-disable-next-line func-names,consistent-return
const breakpointChecker = function () {
    // if larger viewport and multi-row layout needed
    if (breakpoint.matches) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        // or/and do nothing

        // else if a small viewport and column layout needed
    } else if (!breakpoint.matches) {
        // fire small viewport version of swiper
        return enableSwiper();
    }
};

breakpoint.addListener(breakpointChecker);

breakpointChecker();
